import noUiSlider from 'nouislider';


const CALC_SLIDER_MAX_RANGE = 300000;
const CALC_SLIDER_MIN_RANGE = 10000;
const CALC_SLIDER_START_VALUE = 78500;
const CALC_SLIDER_STEP = 1000;

const calcSlider = document.querySelector('.calc-slider__range');
const calcText = document.querySelector('.display-value__text');
const calcLink = document.querySelector('.calc-actions__link');

if (!calcSlider.noUiSlider) {
  noUiSlider.create(calcSlider, {
    range: {
      min: CALC_SLIDER_MIN_RANGE,
      max: CALC_SLIDER_MAX_RANGE,
    },
    start: CALC_SLIDER_START_VALUE,
    step: CALC_SLIDER_STEP,
    connect: 'lower',
  });
}

/**
 * Обновляет текст кнопки «Получить <сумма микрозайма> ТГ.».
 * @param newValue - сумма микрозайма
 */
const refreshCalcLinkText = (newValue) => {
  calcLink.textContent = `Получить ${newValue.toLocaleString('ru-RU')} тг.`;
};

/**
 * Обработчик события blur на input со значением микрозайма
 */
const onCalcTextBlur = () => {
  const currentValue = calcText.value;

  let newValue = null;

  if (currentValue < CALC_SLIDER_MIN_RANGE) {
    newValue = CALC_SLIDER_MIN_RANGE;
    calcText.value = newValue;
    calcSlider.noUiSlider.set(newValue);
  } else if (currentValue > CALC_SLIDER_MAX_RANGE) {
    newValue = CALC_SLIDER_MAX_RANGE;
    calcText.value = newValue;
    calcSlider.noUiSlider.set(newValue);
  } else {
    newValue = currentValue;
    calcSlider.noUiSlider.set(newValue);
  }

  refreshCalcLinkText(newValue);
};

calcText.addEventListener('blur', onCalcTextBlur);

calcSlider.noUiSlider.on('slide', () => {
  const newValue = parseInt(calcSlider.noUiSlider.get());

  calcText.value = newValue;
  refreshCalcLinkText(newValue);
});
